import { checkIfPhoneIsNotValid } from '@/src/modules/build-a-card/validations/validationHelpers'

export async function verifyValidPhoneNumber(
    phone: string,
    setPhoneError: Function,
    isBuyer: boolean = false
) {
    if (!phone) {
        return { cleanedPhoneNumber: '', hasError: false }
    }

    let hasError
    try {
        const isValid = await checkIfPhoneIsNotValid({
            phone: phone,
            isBuyer: isBuyer,
        })

        if (!isValid) {
            setPhoneError(
                'Phone number provided must be a mobile number located in the U.S.A'
            )
            hasError = true
        }
    } catch (e: any) {
        console.error('Failed to check if phone is valid', {
            error: e?.message,
        })

        setPhoneError(
            'Unable to validate phone number provided. Please try again or contact support'
        )
        hasError = true
    }

    return {
        cleanedPhoneNumber: phone.replace(/\D/g, '').replace(/^1/, ''),
        hasError: hasError,
    }
}
